import axios from "axios";
import { useCallback } from "react";
import { useAuth } from "@clerk/react";
import { useQuery } from "@tanstack/react-query";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const fileUrl = (p) => `${API}/files/${p}`;

export function useAuthedApi() {
  const { getToken } = useAuth();
  return useCallback(
    async (cfg) => {
      const token = await getToken();
      return api({ ...cfg, headers: { ...(cfg.headers || {}), Authorization: `Bearer ${token}` } });
    },
    [getToken],
  );
}

export function useMe() {
  const { isSignedIn } = useAuth();
  const authed = useAuthedApi();
  return useQuery({
    queryKey: ["me"],
    queryFn: async () => (await authed({ url: "/me" })).data,
    enabled: !!isSignedIn,
  });
}

export const useMeta = () =>
  useQuery({ queryKey: ["meta"], queryFn: async () => (await api.get("/meta")).data, staleTime: Infinity });

const noRetry4xx = (count, e) => !(e?.response?.status >= 400 && e?.response?.status < 500) && count < 2;

export const useGet = (key, url, params, opts = {}) =>
  useQuery({ queryKey: [key, url, params], queryFn: async () => (await api.get(url, { params })).data, retry: noRetry4xx, ...opts });

export { noRetry4xx };

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || "Etwas ist schiefgelaufen";
};
